import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M9.225.64H3.16A3.036 3.036 0 0 0 .127 3.672v7.885a1.82 1.82 0 0 0 1.213 1.708v.718c0 .67.543 1.213 1.213 1.213h1.213c.67 0 1.212-.543 1.213-1.213v-.606h2.426v.606c.001.67.544 1.213 1.214 1.213h1.213c.67 0 1.212-.543 1.213-1.213v-.718a1.82 1.82 0 0 0 1.213-1.708V3.672A3.036 3.036 0 0 0 9.225.64M3.16 1.853h6.065a1.82 1.82 0 0 1 1.707 1.213h-9.48c.255-.726.94-1.21 1.708-1.213m.606 12.13H2.553v-.606h1.213zm6.065 0H8.618v-.606h1.213zm1.214-2.426a.607.607 0 0 1-.607.607H1.946a.607.607 0 0 1-.606-.607v-1.82h9.705zm0-3.032H1.34V4.279h9.705z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M3.767 10.95c0 .81-1.213.81-1.213 0 0-.808 1.213-.808 1.213 0M9.831 10.95c0 .81-1.213.81-1.213 0 0-.808 1.213-.808 1.213 0"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "11.915",
  height: "11.915",
  x: "8.278",
  y: "8.165",
  fill: "#fff",
  rx: "2.613"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M17.234 9.225a1.555 1.555 0 0 1 1.556 1.555V17a1.555 1.555 0 0 1-1.556 1.556h-6.22a1.556 1.556 0 0 1-1.556-1.555V10.78c0-.859.697-1.555 1.555-1.555zm-2.826 1.859h-2.206v5.528h1.333v-1.875h.85q1.01 0 1.59-.485.578-.483.578-1.293 0-.546-.267-.977a1.76 1.76 0 0 0-.756-.665 2.5 2.5 0 0 0-.982-.23zm.015 1.029q.36.003.57.235.208.231.208.62 0 .353-.203.546t-.59.194h-.874v-1.595z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }